import { useDocumentTitle } from "hooks/useDocumentTitle";
import rightImg from "images/about-hero-right.png";
import { FC } from "react";
import SectionAbout from "./SectionAbout";
import { useData } from "data/data-provider";
import BgGlassmorphism from "designs/DesignA/components/BgGlassmorphism/BgGlassmorphism";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const { aboutUs, companyDetails } = useData();

  // Page title — pulls a sensible default from the FMS-managed about-us
  // section heading (stripped of any HTML tags Quill may have added) before
  // falling back to the SEO title or the literal "About Us". Keeps the
  // page top free of hardcoded copy.
  const stripHtml = (html?: string | null) =>
    (html || "").replace(/<[^>]+>/g, "").trim();
  // 1NOW-1648 / 1NOW-1658: the document title is an *About* title, not the
  // section's marketing headline — /contact already does it this way. The old
  // chain also had an unreachable tail: `About ${""}`.trim() is "About", which
  // is truthy, so "About Us" could never be hit.
  const companyName = companyDetails?.company_name?.trim();
  const pageTitle =
    (companyName ? `About ${companyName}` : "") ||
    companyDetails?.seo_title?.trim() ||
    stripHtml(aboutUs?.heading) ||
    "About Us";

  useDocumentTitle(pageTitle);
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >

      {/* 1NOW-1655: was a flat text-7xl, which wrapped to four lines and ate the
          whole first screen at 375px before any content was visible. */}
      <h1 className="text-3xl sm:text-5xl lg:text-7xl font-semibold text-text-color mt-6 w-full text-center">
        {pageTitle}
      </h1>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-12 lg:py-20 space-y-16 lg:space-y-28">
        {aboutUs && <SectionAbout aboutUs={aboutUs} />}
      </div>
    </div>
  );
};

export default PageAbout;
